import React from 'react';

export default function AlertCard({ show, message, onClose, type = 'info', title }) {
  if (!show) return null;
  let color = '#11998e';
  if (type === 'error') color = '#b91c1c';
  if (type === 'warning') color = '#f59e42';
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.18)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        padding: '2.5rem 2.5rem 2rem 2.5rem',
        minWidth: 340,
        maxWidth: 400,
        textAlign: 'center',
        fontFamily: 'Poppins, Segoe UI, sans-serif',
      }}>
        <h2 style={{ color, fontWeight: 700, fontSize: 24, marginBottom: 12 }}>{title || (type === 'error' ? 'Error' : type === 'warning' ? 'Warning' : 'Info')}</h2>
        <div style={{ color: '#444', fontSize: 18, marginBottom: 8 }}>{message}</div>
        <button onClick={onClose} style={{ marginTop: 16, background: color, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 24px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>OK</button>
      </div>
    </div>
  );
} 